/**
 * SuperDTF Manual Collection Infinite Scroll
 * Custom implementation that manually fetches and appends products
 */
(function() {
  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Initializing SuperDTF manual infinite scroll...');
    
    // Main function to set up the infinite scroll
    function setupInfiniteScroll() {
      // Find key elements
      const loadMoreButton = document.getElementById('loadMoreButton');
      const paginationNext = document.querySelector('.pagination__item--next a');
      const productGrid = document.querySelector('.collection__cards');
      
      // Exit if we don't have the necessary elements
      if (!loadMoreButton || !paginationNext || !productGrid) {
        console.log('Missing required elements for infinite scroll');
        return;
      }
      
      // Remove default click handler and add our custom one
      const newLoadMoreButton = loadMoreButton.cloneNode(true);
      loadMoreButton.parentNode.replaceChild(newLoadMoreButton, loadMoreButton);
      
      // Flag to track loading state
      let isLoading = false;
      
      // Add our custom click handler
      newLoadMoreButton.addEventListener('click', function() {
        if (isLoading) return;
        
        // Update button state
        isLoading = true;
        newLoadMoreButton.disabled = true;
        newLoadMoreButton.textContent = 'Loading...';
        
        // Get the next page URL
        const nextPageUrl = paginationNext.getAttribute('href');
        console.log('Fetching next page:', nextPageUrl);
        
        // Fetch the next page
        fetch(nextPageUrl)
          .then(response => response.text())
          .then(html => {
            // Parse the HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Extract the new products
            const newProducts = doc.querySelectorAll('.collection__cards .o-layout__item');
            console.log('Found', newProducts.length, 'new products');
            
            if (newProducts.length) {
              // Append each new product to the grid
              newProducts.forEach(product => {
                productGrid.appendChild(product);
              });
              
              // Reinitialize any necessary scripts
              if (typeof window.theme !== 'undefined') {
                if (window.theme.animations && typeof window.theme.animations.init === 'function') {
                  window.theme.animations.init();
                }
              }
              
              // Find the next page link in the fetched page
              const newPaginationNext = doc.querySelector('.pagination__item--next a');
              
              if (newPaginationNext) {
                // Update our reference to the next page link
                paginationNext.setAttribute('href', newPaginationNext.getAttribute('href'));
                
                // Reset button state
                newLoadMoreButton.disabled = false;
                newLoadMoreButton.textContent = 'Load more products';
              } else {
                // No more pages, hide the button
                newLoadMoreButton.style.display = 'none';
              }
            } else {
              // No products found, hide the button
              newLoadMoreButton.style.display = 'none';
            }
            
            // Reset loading state
            isLoading = false;
          })
          .catch(error => {
            console.error('Error fetching next page:', error);
            
            // Reset button state on error
            newLoadMoreButton.disabled = false;
            newLoadMoreButton.textContent = 'Load more products';
            isLoading = false;
          });
      });
      
      // Also set up automatic loading when scrolling to the button
      window.addEventListener('scroll', function() {
        if (isLoading) return;
        
        const rect = newLoadMoreButton.getBoundingClientRect();
        const isVisible = 
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + 300;
        
        if (isVisible && !newLoadMoreButton.disabled && newLoadMoreButton.style.display !== 'none') {
          console.log('Load more button is visible, clicking it');
          newLoadMoreButton.click();
        }
      });
    }
    
    // Run setup with a slight delay to ensure all theme scripts are loaded
    setTimeout(setupInfiniteScroll, 1000);
  });
})();